import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useViewModeStore = create()(
  persist(
    (set) => ({
      viewMode: "kanbas",
      setViewMode: (viewMode) => set({ viewMode }),
    }),
    {
      name: "view-mode", // Nombre en localStorage
    },
  ),
);
